import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useReactToPrint } from "react-to-print";
import SubscriptionTabs from './SubscriptionsTabs';

const styles = {
  page: { 
    background: "#f0f2f5", 
    minHeight: "100vh", 
    padding: "20px",
    display: "flex",
    gap: "24px"
  },
  
  formPanel: {
    flex: "0 0 420px",
    background: "#fff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    maxHeight: "calc(100vh - 120px)",
    overflowY: "auto",
    position: "sticky",
    top: "20px"
  },
  formTitle: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#1a1a2e",
    marginBottom: "20px",
    paddingBottom: "12px",
    borderBottom: "2px solid #e8e8e8"
  },
  invoicePanel: {
    flex: 1,
    background: "#fff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    minHeight: "calc(100vh - 120px)",
    overflowY: "auto"
  },
  
  formGroup: {
    marginBottom: "16px"
  },
  formLabel: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#4a4a6a",
    display: "block",
    marginBottom: "4px"
  },
  formInput: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #d4d4d4",
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "Arial, sans-serif",
    background: "#fafafa",
    color: "#1a1a2e",
    transition: "all 0.2s",
    outline: "none"
  },
  formSelect: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #d4d4d4",
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "Arial, sans-serif",
    background: "#fafafa",
    color: "#1a1a2e",
    cursor: "pointer",
    outline: "none"
  },
  formTextarea: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #d4d4d4",
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "Arial, sans-serif",
    background: "#fafafa",
    color: "#1a1a2e",
    minHeight: "60px",
    resize: "vertical",
    outline: "none"
  },
  
  gstToggleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 0"
  },
  toggleSwitch: {
    position: "relative",
    width: "44px",
    height: "24px",
    background: "#d4d4d4",
    borderRadius: "12px",
    cursor: "pointer",
    transition: "background 0.3s"
  },
  toggleSwitchActive: {
    background: "#4a6cf7"
  },
  toggleSlider: {
    position: "absolute",
    top: "2px",
    left: "2px",
    width: "20px",
    height: "20px",
    background: "#fff",
    borderRadius: "50%",
    transition: "transform 0.3s",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
  },
  toggleSliderActive: {
    transform: "translateX(20px)"
  },
  toggleLabel: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#4a4a6a",
    cursor: "pointer"
  },
  
  actionButtons: {
    display: "flex",
    gap: "12px",
    marginTop: "20px",
    paddingTop: "16px",
    borderTop: "2px solid #e8e8e8"
  },
  btnPrimary: {
    flex: 1,
    padding: "10px",
    background: "#4a6cf7",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "all 0.2s"
  },
  btnSecondary: {
    flex: 1,
    padding: "10px",
    background: "#1a1a2e",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    transition: "all 0.2s"
  },
  btnAdd: {
    padding: "8px 20px",
    background: "#10b981",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    transition: "all 0.2s",
    whiteSpace: "nowrap"
  },
  btnRemove: {
    padding: "4px 10px",
    background: "#ef4444",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "11px",
    cursor: "pointer"
  },

  invoiceWrap: { 
    maxWidth: "100%", 
    margin: "0 auto", 
    fontFamily: "'Segoe UI', Arial, sans-serif" 
  },
  invoiceCard: { 
    background: "#fff", 
    borderRadius: "12px", 
    overflow: "hidden", 
    border: "1px solid #e8e8e8"
  },
  invoiceHeader: { 
    background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)", 
    padding: "28px 32px 24px", 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "flex-start",
    position: "relative",
    overflow: "hidden"
  },
  headerDecor: {
    position: "absolute",
    right: "-40px",
    top: "-40px",
    width: "200px",
    height: "200px",
    background: "rgba(255,255,255,0.03)",
    borderRadius: "50%"
  },
  headerDecor2: {
    position: "absolute",
    right: "80px",
    bottom: "-60px",
    width: "150px",
    height: "150px",
    background: "rgba(255,255,255,0.02)",
    borderRadius: "50%"
  },
  invoiceTitleBlock: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    gap: "16px"
  },
  logoContainer: {
    width: "60px",
    height: "60px",
    borderRadius: "10px",
    background: "rgba(255,255,255,0.95)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    flexShrink: 0
  },
  logoImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    display: "block"
  },
  invoiceLabel: { 
    fontSize: "10px", 
    letterSpacing: "3px", 
    textTransform: "uppercase", 
    color: "rgba(255,255,255,0.6)", 
    marginBottom: "4px",
    fontWeight: 600
  },
  invoiceTitle: { 
    fontSize: "32px", 
    fontWeight: 800, 
    color: "#fff", 
    letterSpacing: "2px", 
    lineHeight: 1 
  },
  invoiceTagline: { 
    fontSize: "12px", 
    color: "rgba(255,255,255,0.6)", 
    marginTop: "6px" 
  },
  invoiceBody: { 
    padding: "24px 32px 20px" 
  },
  billSection: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "24px",
    marginBottom: "24px"
  },
  billBox: {
    padding: "16px 20px",
    background: "#f8f9fc",
    borderRadius: "8px",
    border: "1px solid #e8e8e8"
  },
  billBoxTitle: {
    fontSize: "10px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "#6b6b8a",
    fontWeight: 700,
    marginBottom: "8px",
    paddingBottom: "6px",
    borderBottom: "1px solid #e8e8e8"
  },
  billBoxContent: {
    fontSize: "13px",
    color: "#1a1a2e",
    lineHeight: 1.8
  },
  billBoxName: {
    fontWeight: 700,
    fontSize: "15px",
    color: "#1a1a2e",
    marginBottom: "2px"
  },
  planTable: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px"
  },
  tableHeader: {
    background: "#f8f9fc",
    borderBottom: "2px solid #e8e8e8"
  },
  tableHeaderCell: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: "11px",
    fontWeight: 700,
    color: "#6b6b8a",
    letterSpacing: "1px",
    textTransform: "uppercase"
  },
  tableRow: {
    borderBottom: "1px solid #f0f2f5"
  },
  tableRowAlt: {
    background: "#fafafa",
    borderBottom: "1px solid #f0f2f5"
  },
  tableCell: {
    padding: "12px 16px",
    fontSize: "13px",
    color: "#1a1a2e",
    verticalAlign: "middle"
  },
  tableCellPlan: {
    padding: "12px 16px",
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a2e",
    verticalAlign: "middle"
  },
  tableCellAmount: {
    padding: "12px 16px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#4a6cf7",
    textAlign: "right",
    verticalAlign: "middle"
  },
  tableCellBilling: {
    padding: "12px 16px",
    fontSize: "12px",
    color: "#6b6b8a",
    verticalAlign: "middle"
  },
  sectionTitle: { 
    fontSize: "13px", 
    fontWeight: 700, 
    color: "#1a1a2e", 
    letterSpacing: "1.5px", 
    textTransform: "uppercase", 
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  divider: { 
    border: "none", 
    borderTop: "2px solid #f0f2f5", 
    margin: "20px 0" 
  },
  priceBox: { 
    border: "2px solid #e8e8e8", 
    borderRadius: "10px", 
    overflow: "hidden",
    background: "#fff",
    marginTop: "12px",
    maxWidth: "400px",
    marginLeft: "auto"
  },
  priceHeader: { 
    background: "#f8f9fc", 
    padding: "10px 20px", 
    fontSize: "11px", 
    letterSpacing: "1.5px", 
    textTransform: "uppercase", 
    fontWeight: 700,
    color: "#1a1a2e",
    borderBottom: "1px solid #e8e8e8"
  },
  priceRow: { 
    display: "flex", 
    justifyContent: "space-between", 
    padding: "10px 20px", 
    borderBottom: "1px solid #f0f2f5", 
    fontSize: "13px", 
    color: "#4a4a6a" 
  },
  priceRowTotal: { 
    display: "flex", 
    justifyContent: "space-between", 
    padding: "14px 20px", 
    background: "#4a6cf7", 
    fontSize: "16px", 
    color: "#fff", 
    fontWeight: 800,
    borderRadius: "0 0 8px 8px"
  },
  invoiceFooter: { 
    borderTop: "2px solid #f0f2f5", 
    padding: "14px 32px", 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center",
    background: "#fafafa"
  },
  footerNote: { 
    fontSize: "10px", 
    color: "#6b6b8a", 
    maxWidth: "400px", 
    lineHeight: 1.6 
  },
  footerBrand: { 
    textAlign: "right" 
  },
  footerBrandName: { 
    fontWeight: 700, 
    fontSize: "14px", 
    color: "#1a1a2e" 
  },
  footerBrandSub: { 
    fontSize: "10px", 
    color: "#6b6b8a" 
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
    flexDirection: "column",
    gap: "16px"
  },
  manualPlanEntry: {
    border: "1px solid #e8e8e8",
    borderRadius: "8px",
    padding: "12px",
    marginTop: "8px",
    background: "#fafafa"
  },
  planRow: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    marginBottom: "8px",
    flexWrap: "wrap"
  },
  dateRow: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    flexWrap: "wrap"
  },
  dateInput: {
    padding: "6px 10px",
    border: "1px solid #d4d4d4",
    borderRadius: "6px",
    fontSize: "12px",
    fontFamily: "Arial, sans-serif",
    background: "#fff",
    color: "#1a1a2e",
    outline: "none",
    flex: 1,
    minWidth: "120px"
  },
  planBadge: {
    fontSize: "9px",
    padding: "1px 8px",
    borderRadius: "10px",
    marginLeft: "6px",
    background: "#dbeafe",
    color: "#1e40af"
  },
  manualPlanItem: {
    background: "#fff", 
    padding: "8px 10px", 
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
    marginTop: "6px"
  },
  manualPlanContent: {
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center"
  },
  manualPlanInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap"
  },
  manualPlanName: {
    fontSize: "13px", 
    fontWeight: 500
  },
  manualPlanPrice: {
    fontSize: "12px", 
    color: "#666"
  },
  manualPlanDates: {
    fontSize: "10px", 
    color: "#6b6b8a", 
    marginTop: "2px"
  }
};

const printStyles = `
  @media print {
    .form-panel {
      display: none !important;
    }
    .invoice-panel {
      flex: 1 !important;
      padding: 0 !important;
      box-shadow: none !important;
      border-radius: 0 !important;
    }
    .no-print {
      display: none !important;
    }
    #layout-wrapper {
      padding: 0 !important;
      margin: 0 !important;
    }
    .main-content {
      margin: 0 !important;
      padding: 0 !important;
    }
    .page-content {
      padding: 0 !important;
    }
    .container-fluid {
      padding: 0 !important;
    }
    .card {
      border: none !important;
      box-shadow: none !important;
      margin: 0 !important;
    }
    .card-body {
      padding: 0 !important;
    }
    .gst-toggle-section {
      display: none !important;
    }
    body {
      margin: 0 !important;
      padding: 0 !important;
    }
    /* Ensure logo prints properly */
    .invoice-logo {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    .invoice-header-gradient {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
  }
`;

const ManualSubscriptionInvoice = () => {
  const params = useParams();
  const contentRef = useRef();
  const [pageLoading, setPageLoading] = useState(false);
  const { user, loading } = useAuth();
  
  const planOptions = [
    { 
      value: "basic", 
      label: "Basic Plan", 
      price: 999,
      basePrice: 0,
      billingCycle: "Monthly"
    },
    { 
      value: "starter", 
      label: "Starter Plan", 
      price: 2999,
      basePrice: 0,
      billingCycle: "Monthly"
    },
    { 
      value: "b2c_website", 
      label: "B2C Website Launch", 
      price: 0,
      basePrice: 0,
      billingCycle: "Yearly"
    },
    { 
      value: "b2c_portal", 
      label: "B2C Travel Portal", 
      price: 4999,
      basePrice: 0,
      billingCycle: "One Time"
    },
    { 
      value: "b2b_portal", 
      label: "B2B Travel Portal", 
      price: 4999,
      basePrice: 0,
      billingCycle: "One Time"
    },
    { 
      value: "b2e_portal", 
      label: "B2E Corporate Portal", 
      price: 4999,
      basePrice: 0,
      billingCycle: "One Time"
    }
  ];

  const [invoiceData, setInvoiceData] = useState({
    subscriptionId: "INV-" + moment().format("DDMMYYYY"),
    invoiceDate: moment().format("YYYY-MM-DD"),
    billingPeriodStart: moment().format("YYYY-MM-DD"),
    billingPeriodEnd: moment().add(1, 'year').format("YYYY-MM-DD"),
    customerName: "",
    customerEmail: "",
    customerPhone: "",
    selectedPlans: ["basic"],
    includeGST: false,
    gstPercentage: 18,
    notes: "",
    paymentId: ""
  });

  const [manualPlans, setManualPlans] = useState([]);
  const [manualPlanName, setManualPlanName] = useState("");
  const [manualPlanPrice, setManualPlanPrice] = useState("");
  const [manualPlanStartDate, setManualPlanStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [manualPlanEndDate, setManualPlanEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [calculatedBaseTotal, setCalculatedBaseTotal] = useState(0);
  const [calculatedGST, setCalculatedGST] = useState(0);

  const handlePrint = useReactToPrint({
    contentRef: contentRef,
    documentTitle: `${invoiceData.customerName || 'Customer'}_Subscription_Invoice_${moment().format('DDMMYYYY')}`,
  });

  const handlePDF = () => {
    const input = contentRef.current;
    if (input) {
      html2canvas(input, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        onclone: (document) => {
          const images = document.getElementsByTagName('img');
          return Promise.all(
            Array.from(images).map((img) => {
              if (img.complete) return Promise.resolve();
              return new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = resolve;
              });
            })
          );
        }
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        
        pdf.save(`${invoiceData.customerName || 'Customer'}_Subscription_Invoice_${moment().format('DDMMYYYY')}.pdf`);
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePlanToggle = (planValue) => {
    setInvoiceData(prev => {
      const currentPlans = [...prev.selectedPlans];
      if (currentPlans.includes(planValue)) {
        const updatedPlans = currentPlans.filter(p => p !== planValue);
        return { ...prev, selectedPlans: updatedPlans };
      } else {
        return { ...prev, selectedPlans: [...currentPlans, planValue] };
      }
    });
  };

  const handleGSTToggle = () => {
    setInvoiceData(prev => ({
      ...prev,
      includeGST: !prev.includeGST
    }));
  };

  const handleGSTPercentageChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setInvoiceData(prev => ({
      ...prev,
      gstPercentage: value
    }));
  };

  const handleAddManualPlan = () => {
    if (manualPlanName.trim() && manualPlanPrice) {
      const price = parseFloat(manualPlanPrice) || 0;
      const newPlan = {
        value: `manual_${Date.now()}`,
        label: manualPlanName.trim(),
        price: price,
        basePrice: 0,
        billingCycle: "Custom",
        isManual: true,
        startDate: manualPlanStartDate,
        endDate: manualPlanEndDate
      };
      setManualPlans([...manualPlans, newPlan]);
      setInvoiceData(prev => ({
        ...prev,
        selectedPlans: [...prev.selectedPlans, newPlan.value]
      }));
      setManualPlanName("");
      setManualPlanPrice("");
      setManualPlanStartDate(moment().format("YYYY-MM-DD"));
      setManualPlanEndDate(moment().format("YYYY-MM-DD"));
    }
  };

  const handleRemoveManualPlan = (planValue) => {
    setManualPlans(manualPlans.filter(p => p.value !== planValue));
    setInvoiceData(prev => ({
      ...prev,
      selectedPlans: prev.selectedPlans.filter(p => p !== planValue)
    }));
  };

  // GST CALCULATION - Updated
  useEffect(() => {
    const allPlans = [...planOptions, ...manualPlans];
    const selectedPlansData = invoiceData.selectedPlans
      .map(planValue => allPlans.find(p => p.value === planValue))
      .filter(Boolean);

    const totalPrice = selectedPlansData.reduce((sum, plan) => sum + (plan.price || 0), 0);
    
    let baseTotal = totalPrice;
    let gstAmount = 0;
    let displayTotal = totalPrice;

    if (invoiceData.includeGST && invoiceData.gstPercentage > 0) {
      // GST INCLUDED: Price includes GST, calculate base and GST from total
      const gstRate = invoiceData.gstPercentage / 100;
      baseTotal = totalPrice / (1 + gstRate);
      gstAmount = totalPrice - baseTotal;
      displayTotal = totalPrice;
    } else {
      // GST EXCLUDED: Price is without GST, add GST on top
      const gstRate = invoiceData.gstPercentage / 100;
      baseTotal = totalPrice;
      gstAmount = totalPrice * gstRate;
      displayTotal = totalPrice + gstAmount;
    }

    setCalculatedBaseTotal(baseTotal);
    setCalculatedGST(gstAmount);
    setCalculatedTotal(displayTotal);

  }, [invoiceData.selectedPlans, invoiceData.includeGST, invoiceData.gstPercentage, manualPlans]);

  const GetData = () => {
    setPageLoading(true);
    if (params.subscriptionId) {
      apiService
        .getAll(config.GETSUBSCRIPTIONDETAILS + "/" + params.subscriptionId)
        .then((res) => {
          if (res) {
            setInvoiceData(prev => ({
              ...prev,
              subscriptionId: res.subscriptionId || prev.subscriptionId,
              customerName: res.customerName || prev.customerName,
              customerEmail: res.customerEmail || prev.customerEmail,
              selectedPlans: res.planTypes || prev.selectedPlans,
              paymentId: res.paymentId || prev.paymentId
            }));
          }
          setPageLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching subscription data", err);
          setPageLoading(false);
        });
    } else {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) return <p>Please log in</p>;

  const allPlans = [...planOptions, ...manualPlans];
  const selectedPlansData = invoiceData.selectedPlans
    .map(planValue => {
      const plan = allPlans.find(p => p.value === planValue);
      if (!plan) return null;
      
      if (plan.price > 0 && invoiceData.includeGST && invoiceData.gstPercentage > 0) {
        const gstRate = invoiceData.gstPercentage / 100;
        const basePrice = plan.price / (1 + gstRate);
        return {
          ...plan,
          basePrice: basePrice,
          gstAmount: plan.price - basePrice
        };
      }
      return { 
        ...plan, 
        basePrice: plan.price || 0, 
        gstAmount: 0 
      };
    })
    .filter(Boolean);

  const formatDate = (date) => moment(date).format("DD MMM YYYY");

  const getBillingPeriod = (plan) => {
    if (plan.isManual && plan.startDate && plan.endDate) {
      return `${formatDate(plan.startDate)} - ${formatDate(plan.endDate)}`;
    }
    
    const start = moment(invoiceData.billingPeriodStart);
    const end = moment(invoiceData.billingPeriodEnd);
    
    if (plan.billingCycle === 'Monthly') {
      const monthStart = start.format("DD MMM YYYY");
      const monthEnd = start.clone().add(1, 'month').format("DD MMM YYYY");
      return `${monthStart} - ${monthEnd}`;
    } else if (plan.billingCycle === 'Yearly') {
      return `${start.format("DD MMM YYYY")} - ${end.format("DD MMM YYYY")}`;
    } else if (plan.billingCycle === 'One Time') {
      return "One Time Payment";
    }
    return "—";
  };

  const getLogoUrl = () => {
    if (user?.logo) {
      return user.logo;
    }
    return "/assets/images/Zotrai.png";
  };

  return (
    <div id="layout-wrapper">
      <style>{printStyles}</style>
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card" style={{ border: "none", boxShadow: "none", background: "transparent" }}>
                <div className="p-2">
                  <SubscriptionTabs pageName="SUBSCRIPTION INVOICE" />
                </div>
                <div className="card-body" style={{ padding: "0" }}>
                  {pageLoading ? (
                    <div style={styles.loadingContainer}>
                      <img src="/assets/images/loader.webp" width="64px" height="64px" alt="loading" loading="lazy" />
                      <p>Loading, Please wait...</p>
                    </div>
                  ) : (
                    <div style={styles.page}>
                      {/* LEFT PANEL - FORM */}
                      <div className="form-panel" style={styles.formPanel}>
                        <div style={styles.formTitle}>📝 Invoice Details</div>
                        
                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Invoice Date</label>
                          <input
                            type="date"
                            name="invoiceDate"
                            value={invoiceData.invoiceDate}
                            onChange={handleInputChange}
                            style={styles.formInput}
                          />
                        </div>
                        
                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Invoice No</label>
                          <input
                            type="text"
                            name="subscriptionId"
                            value={invoiceData.subscriptionId}
                            onChange={handleInputChange}
                            style={styles.formInput}
                            placeholder="Enter subscription ID"
                          />
                        </div>

                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Payment ID</label>
                          <input
                            type="text"
                            name="paymentId"
                            value={invoiceData.paymentId}
                            onChange={handleInputChange}
                            style={styles.formInput}
                            placeholder="Enter payment ID (e.g., PAY-1234567890)"
                          />
                        </div>

                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Customer Name *</label>
                          <input
                            type="text"
                            name="customerName"
                            value={invoiceData.customerName}
                            onChange={handleInputChange}
                            style={styles.formInput}
                            placeholder="Enter customer name"
                          />
                        </div>
                        
                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Email</label>
                          <input
                            type="email"
                            name="customerEmail"
                            value={invoiceData.customerEmail}
                            onChange={handleInputChange}
                            style={styles.formInput}
                            placeholder="Enter email address"
                          />
                        </div>
                        
                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Phone</label>
                          <input
                            type="text"
                            name="customerPhone"
                            value={invoiceData.customerPhone}
                            onChange={handleInputChange}
                            style={styles.formInput}
                            placeholder="Enter phone number"
                          />
                        </div>

                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Select Plans (Multiple)</label>
                          <div style={{ display: "flex", flexDirection: "column", gap: "6px", maxHeight: "200px", overflowY: "auto" }}>
                            {planOptions.map((plan) => {
                              const isSelected = invoiceData.selectedPlans.includes(plan.value);
                              const displayPrice = plan.price > 0 ? `INR${plan.price}` : "Free";
                              return (
                                <label key={plan.value} style={{ 
                                  display: "flex", 
                                  alignItems: "center", 
                                  gap: "10px", 
                                  fontSize: "12px", 
                                  cursor: "pointer", 
                                  padding: "8px 12px", 
                                  background: isSelected ? "#e8edff" : "#fafafa", 
                                  borderRadius: "6px", 
                                  border: isSelected ? "2px solid #4a6cf7" : "1px solid #e8e8e8",
                                  transition: "all 0.2s"
                                }}>
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => handlePlanToggle(plan.value)}
                                    style={{ width: "16px", height: "16px", cursor: "pointer" }}
                                  />
                                  <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: isSelected ? 600 : 400 }}>
                                      {plan.label}
                                      <span style={styles.planBadge}>
                                        {plan.billingCycle}
                                      </span>
                                    </div>
                                  </div>
                                  <span style={{ fontWeight: 700, color: "#4a6cf7" }}>
                                    {displayPrice}
                                  </span>
                                </label>
                              );
                            })}
                          </div>
                        </div>

                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Add Custom Plan</label>
                          <div style={styles.manualPlanEntry}>
                            <div style={styles.planRow}>
                              <input
                                type="text"
                                value={manualPlanName}
                                onChange={(e) => setManualPlanName(e.target.value)}
                                style={{ ...styles.formInput, flex: 1 }}
                                placeholder="Plan name"
                              />
                              <input
                                type="number"
                                value={manualPlanPrice}
                                onChange={(e) => setManualPlanPrice(e.target.value)}
                                style={{ ...styles.formInput, flex: 1 }}
                                placeholder="Price (INR)"
                                min="0"
                              />
                            </div>
                            
                            <div style={styles.dateRow}>
                              <label style={{ fontSize: "11px", color: "#4a4a6a", fontWeight: 600, minWidth: "35px" }}>
                                From:
                              </label>
                              <input
                                type="date"
                                value={manualPlanStartDate}
                                onChange={(e) => {
                                  const date = e.target.value;
                                  setManualPlanStartDate(date);
                                  if (new Date(date) > new Date(manualPlanEndDate)) {
                                    setManualPlanEndDate(date);
                                  }
                                }}
                                style={styles.dateInput}
                              />
                              <label style={{ fontSize: "11px", color: "#4a4a6a", fontWeight: 600, minWidth: "25px" }}>
                                To:
                              </label>
                              <input
                                type="date"
                                value={manualPlanEndDate}
                                onChange={(e) => setManualPlanEndDate(e.target.value)}
                                style={styles.dateInput}
                              />
                              <button style={styles.btnAdd} onClick={handleAddManualPlan}>
                                + Add
                              </button>
                            </div>
                            
                            {manualPlans.map((plan) => (
                              <div key={plan.value} style={styles.manualPlanItem}>
                                <div style={styles.manualPlanContent}>
                                  <div style={styles.manualPlanInfo}>
                                    <span style={styles.manualPlanName}>{plan.label}</span>
                                    <span style={styles.manualPlanPrice}>INR{plan.price}</span>
                                    <div style={styles.manualPlanDates}>
                                      {formatDate(plan.startDate)} - {formatDate(plan.endDate)}
                                    </div>
                                  </div>
                                  <button 
                                    style={styles.btnRemove}
                                    onClick={() => handleRemoveManualPlan(plan.value)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Billing Start Date</label>
                          <input
                            type="date"
                            name="billingPeriodStart"
                            value={invoiceData.billingPeriodStart}
                            onChange={handleInputChange}
                            style={styles.formInput}
                          />
                        </div>

                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Billing End Date</label>
                          <input
                            type="date"
                            name="billingPeriodEnd"
                            value={invoiceData.billingPeriodEnd}
                            onChange={handleInputChange}
                            style={styles.formInput}
                          />
                        </div>

                        <div style={styles.gstToggleRow}>
                          <div 
                            style={{
                              ...styles.toggleSwitch,
                              ...(invoiceData.includeGST ? styles.toggleSwitchActive : {})
                            }}
                            onClick={handleGSTToggle}
                          >
                            <div 
                              style={{
                                ...styles.toggleSlider,
                                ...(invoiceData.includeGST ? styles.toggleSliderActive : {})
                              }}
                            />
                          </div>
                          <span style={styles.toggleLabel}>Include GST</span>
                          {invoiceData.includeGST && (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                              <input
                                type="number"
                                value={invoiceData.gstPercentage}
                                onChange={handleGSTPercentageChange}
                                style={{ ...styles.formInput, maxWidth: "80px" }}
                                min="0"
                                max="100"
                                step="0.01"
                              />
                              <span style={{ fontSize: "13px", color: "#4a4a6a" }}>%</span>
                            </div>
                          )}
                        </div>

                        <div style={styles.formGroup}>
                          <label style={styles.formLabel}>Additional Notes</label>
                          <textarea
                            name="notes"
                            value={invoiceData.notes}
                            onChange={handleInputChange}
                            style={styles.formTextarea}
                            placeholder="Enter notes..."
                          />
                        </div>

                        <div className="no-print" style={styles.actionButtons}>
                          <button style={styles.btnPrimary} onClick={handlePrint}>
                            🖨️ Print
                          </button>
                          <button style={styles.btnSecondary} onClick={handlePDF}>
                            📥 Download PDF
                          </button>
                        </div>
                      </div>

                      {/* RIGHT PANEL - INVOICE PREVIEW */}
                      <div className="invoice-panel" style={styles.invoicePanel}>
                        <div ref={contentRef} style={styles.invoiceWrap}>
                          <div style={styles.invoiceCard}>
                            <div style={{ ...styles.invoiceHeader, className: "invoice-header-gradient" }}>
                              <div style={styles.headerDecor}></div>
                              <div style={styles.headerDecor2}></div>
                              <div style={styles.invoiceTitleBlock}>
                                <div className="invoice-logo" style={styles.logoContainer}>
                                  <img 
                                    src={getLogoUrl()} 
                                    alt="Company Logo" 
                                    style={styles.logoImage}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = "/assets/images/Zotrai.png";
                                    }}
                                    crossOrigin="anonymous"
                                  />
                                </div>
                                <div>
                                  <div style={styles.invoiceLabel}>Subscription Service</div>
                                  <div style={styles.invoiceTitle}>INVOICE</div>
                                  <div style={styles.invoiceTagline}>Subscription Tax Invoice</div>
                                </div>
                              </div>
                              <div style={{ textAlign: "right", position: "relative", zIndex: 1 }}>
                                <div style={{ fontSize: "14px", fontWeight: 600, color: "#fff" }}>Invoice #</div>
                                <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.7)" }}>{invoiceData.subscriptionId}</div>
                                <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", marginTop: "4px" }}>
                                  Date: {formatDate(invoiceData.invoiceDate)}
                                </div>
                                {invoiceData.paymentId && (
                                  <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", marginTop: "4px", fontWeight: 600 }}>
                                    Payment ID: {invoiceData.paymentId}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div style={styles.invoiceBody}>
                              <div style={styles.billSection}>
                                <div style={styles.billBox}>
                                  <div style={styles.billBoxTitle}>📤 Bill From</div>
                                  <div style={styles.billBoxContent}>
                                    <div style={styles.billBoxName}>{user?.companyname || "Your Company"}</div>
                                    <div>{user?.companyEmail || "email@company.com"}</div>
                                    <div>{user?.companyPhone || "+91 9876543210"}</div>
                                    {user?.companygstno && <div>GST: {user.companygstno}</div>}
                                  </div>
                                </div>

                                <div style={styles.billBox}>
                                  <div style={styles.billBoxTitle}>📥 Bill To</div>
                                  <div style={styles.billBoxContent}>
                                    <div style={styles.billBoxName}>{invoiceData.customerName || "—"}</div>
                                    <div>{invoiceData.customerEmail || "—"}</div>
                                    <div>{invoiceData.customerPhone || "—"}</div>
                                  </div>
                                </div>
                              </div>

                              <div style={styles.sectionTitle}>📋 Plan Details</div>
                              <table style={styles.planTable}>
                                <thead style={styles.tableHeader}>
                                  <tr>
                                    <th style={styles.tableHeaderCell}>#</th>
                                    <th style={styles.tableHeaderCell}>Plan Name</th>
                                    <th style={styles.tableHeaderCell}>Billing Period</th>
                                    <th style={{ ...styles.tableHeaderCell, textAlign: "right" }}>Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedPlansData.length === 0 ? (
                                    <tr>
                                      <td colSpan={4} style={{ ...styles.tableCell, textAlign: "center", color: "#999", padding: "20px" }}>
                                        No plans selected
                                      </td>
                                    </tr>
                                  ) : (
                                    selectedPlansData.map((plan, index) => {
                                      return (
                                        <tr key={plan.value} style={index % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
                                          <td style={styles.tableCell}>{index + 1}</td>
                                          <td style={styles.tableCellPlan}>
                                            {plan.label}
                                          </td>
                                          <td style={styles.tableCellBilling}>
                                            {plan.isManual && plan.startDate && plan.endDate 
                                              ? `${formatDate(plan.startDate)} - ${formatDate(plan.endDate)}`
                                              : getBillingPeriod(plan)
                                            }
                                          </td>
                                          <td style={styles.tableCellAmount}>
                                            {plan.price === 0 ? 'FREE' : `INR${plan.price}`}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  )}
                                </tbody>
                              </table>

                              {invoiceData.notes && (
                                <>
                                  <div style={styles.sectionTitle}>📝 Notes</div>
                                  <div style={{ fontSize: "13px", color: "#4a4a6a", marginBottom: "16px", background: "#f8f9fc", padding: "12px 16px", borderRadius: "8px" }}>
                                    {invoiceData.notes}
                                  </div>
                                </>
                              )}

                              <hr style={styles.divider} />

                              <div style={styles.sectionTitle}>💰 Payment Summary</div>
                              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <div style={styles.priceBox}>
                                  <div style={styles.priceHeader}>Amount Details</div>
                                  {selectedPlansData.map((plan) => (
                                    <div key={plan.value} style={styles.priceRow}>
                                      <span>{plan.label}</span>
                                      <span style={{ fontWeight: 600 }}>
                                        {plan.price === 0 ? 'FREE' : `INR${plan.price}`}
                                      </span>
                                    </div>
                                  ))}
                                  
                                  {/* GST BREAKDOWN - Show based on toggle state */}
                                  {invoiceData.includeGST ? (
                                    // GST INCLUDED: Price includes GST
                                    <>
                                      {selectedPlansData.filter(p => p.price > 0).length > 0 && (
                                        <>
                                          <div style={{ ...styles.priceRow, borderTop: "1px solid #e8e8e8", paddingTop: "10px", marginTop: "4px" }}>
                                            <span style={{ fontWeight: 600 }}>Subtotal (without GST)</span>
                                            <span style={{ fontWeight: 600 }}>INR {calculatedBaseTotal.toFixed(2)}</span>
                                          </div>
                                          <div style={styles.priceRow}>
                                            <span>GST ({invoiceData.gstPercentage}%)</span>
                                            <span style={{ fontWeight: 600 }}>+ INR {calculatedGST.toFixed(2)}</span>
                                          </div>
                                          <div style={{ ...styles.priceRow, borderBottom: "2px solid #e8e8e8", fontWeight: 700 }}>
                                            <span>Total (incl. GST)</span>
                                            <span style={{ fontWeight: 700 }}>INR {calculatedTotal.toFixed(2)}</span>
                                          </div>
                                        </>
                                      )}
                                      <div style={styles.priceRowTotal}>
                                        <span>Grand Total :</span>
                                        <span>INR {calculatedTotal.toFixed(2)}</span>
                                      </div>
                                    </>
                                  ) : (
                                    // GST EXCLUDED: Price without GST, add GST on top
                                    <>
                                      {selectedPlansData.filter(p => p.price > 0).length > 0 && calculatedGST > 0 && (
                                        <>
                                          <div style={{ ...styles.priceRow, borderTop: "1px solid #e8e8e8", paddingTop: "10px", marginTop: "4px" }}>
                                            <span style={{ fontWeight: 600 }}>Subtotal</span>
                                            <span style={{ fontWeight: 600 }}>INR {calculatedBaseTotal.toFixed(2)}</span>
                                          </div>
                                          <div style={styles.priceRow}>
                                            <span>GST ({invoiceData.gstPercentage}%)</span>
                                            <span style={{ fontWeight: 600 }}>+ INR {calculatedGST.toFixed(2)}</span>
                                          </div>
                                        </>
                                      )}
                                      <div style={styles.priceRowTotal}>
                                        <span>Total Amount :</span>
                                        <span>INR {calculatedTotal.toFixed(2)}</span>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div style={styles.invoiceFooter}>
                              <div style={styles.footerNote}>
                                This is a computer-generated invoice. No signature required.
                                <br />
                                For queries, contact {user?.companyEmail || "support@company.com"}
                              </div>
                              <div style={styles.footerBrand}>
                                <div style={styles.footerBrandName}>{user?.brandName || "Your Company"}</div>
                                <div style={styles.footerBrandSub}>Authorized Service Provider</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualSubscriptionInvoice;